import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { ReactComponent as WarnIcon } from 'assets/icons/warning_reco.svg';
import { ReactComponent as NeutralIcon } from 'assets/icons/neutral.svg';
import { ReactComponent as GoodIcon } from 'assets/icons/good.svg';
import { ReactComponent as BulbIcon } from 'assets/icons/bulb.svg';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
`;

const Ul = styled.ul`
  position: absolute;
  background: white;
  padding: 0;
  margin: 0;
  bottom: -4.5rem;
  left: 0;
  display: flex;
  flex-direction: column;
  list-style-type: none;
`;

const Li = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    border: 1px solid black;
  }
`;

const Shadow = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: transparent;
  top: 0;
  left: 0;
`;

const renderIcon = (icon: string) => {
  switch (icon) {
    case 'warn':
      return <WarnIcon />;
    case 'neutral':
      return <NeutralIcon />;
    case 'good':
      return <GoodIcon />;
    case 'bulb':
      return <BulbIcon />;
    default:
      return <WarnIcon />;
  }
};

const Select = ({ field: { name, value }, form: { setFieldValue } }: any) => {
  const [isOpen, setIsOpen] = useState(false);

  const changeValue = (icon: string) => {
    setFieldValue(name, icon);
    setIsOpen(false);
  };

  return (
    <Container>
      <p onClick={() => setIsOpen(!isOpen)}>{renderIcon(value)}</p>
      {isOpen && <Shadow onClick={() => setIsOpen(false)} />}
      {isOpen && (
        <Ul>
          <Li onClick={() => changeValue('warn')}>{renderIcon('warn')}</Li>
          <Li onClick={() => changeValue('neutral')}>
            {renderIcon('neutral')}
          </Li>
          <Li onClick={() => changeValue('good')}>{renderIcon('good')}</Li>
          <Li onClick={() => changeValue('bulb')}>{renderIcon('bulb')}</Li>
        </Ul>
      )}
    </Container>
  );
};

export default Select;
